module.exports = __webpack_public_path__ + "img/268.12d2bdd9.png";